import { isHostInDomains, parseHttpUrl } from './urlValidation';

export type VideoPlatform = 'YouTube' | 'Vimeo';

export const parseSupportedVideoUrl = (
  value: string,
): { url: URL; platform: VideoPlatform } | null => {
  const url = parseHttpUrl(value);
  if (!url) return null;

  if (isHostInDomains(url.hostname, ['youtube.com', 'youtu.be'])) {
    return { url, platform: 'YouTube' };
  }
  if (isHostInDomains(url.hostname, ['vimeo.com'])) {
    return { url, platform: 'Vimeo' };
  }

  return null;
};
